import React from "react";
import BannerImg from "../../assets/images/why-us/banner.png";
import SectionOneImg from "../../assets/images/why-us/section_one.png";
import StepOneImg from "../../assets/images/why-us/step_one.png";
import StepTwoImg from "../../assets/images/why-us/step_two.png";
import StepThreeImg from "../../assets/images/why-us/step_three.png";

export default function WhyDropshippingWithUs() {
  return (
    <div className="w-full bg-white text-slate-800">
      {/* Banner (same style as your commented version) */}
      <section
        className="relative flex items-center justify-center text-center h-[250px] sm:h-[200px] rounded-xl overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,.55), rgba(0,0,0,.55)), url(${BannerImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h1
          className="px-4 text-white font-bold tracking-tight
                     text-4xl sm:text-3xl md:text-5xl leading-tight"
        >
          Why Work With{" "}
          <span className="text-[var(--web-primary-color)]">Importerr</span>
        </h1>
      </section>

      {/* Hero / Intro */}
      <section className="relative overflow-hidden">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center py-6 lg:py-10">
            <div>
              <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">
                Why Work With Us
              </h2>
              <p className="mt-5 text-base sm:text-lg leading-7 sm:leading-8 text-slate-700">
                At <strong>Importerr</strong>, we make global sourcing effortless, transparent,
                 and profitable for everyone — whether you’re a <strong> D2C brand, marketplace seller, startup founder, retailer</strong>,
                  or even a <strong> student exploring new business ideas.</strong>
                <br /><br/>
                We’re not just a sourcing platform — we’re your <strong>end-to-end importing partner</strong>,
                 powered by <strong>AI and global trade expertise.</strong>
              </p>
            </div>

            <div className="relative">
              <div className="absolute -inset-4 -z-10 rounded-3xl bg-gradient-to-tr from-indigo-100 via-sky-100 to-teal-100 blur-2xl" />
              <img
                src={SectionOneImg}
                alt="Importerr hero"
                className="w-full rounded-2xl shadow-xl h-[250px] sm:h-[300px]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Importerr – Feature Cards (NO decorative 3 images after this block) */}
      <section className="py-8 sm:py-12 bg-slate-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h3 className="text-2xl sm:text-3xl font-bold text-[var(--web-secondary-color)] mb-6">
            Why Choose Importerr
          </h3>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              {
                icon: "🌍",
                title: "Global Access, Made Simple",
                body:
                  "Discover trending and high-demand products from verified international suppliers — all in one place.",
              },
              {
                icon: "⚙️",
                title: "AI-Powered Product Discovery",
                body:
                  "Our AI suggests the best products, suppliers, and pricing — helping you make smarter import decisions instantly.",
              },
              {
                icon: "🚚",
                title: "End-to-End Import Support",
                body:
                  "We handle freight, customs clearance, and delivery within India, ensuring a seamless experience from order to arrival.",
              },
              {
                icon: "💰",
                title: "No Middlemen. No Hidden Costs.",
                body:
                  "Import directly with transparent pricing — no agents, no commissions, no confusion.",
              },
              {
                icon: "🧾",
                title: "Built for Everyone",
                body:
                  "Whether you’re a brand or an aspiring entrepreneur, Importerr empowers you to build your asset-light global business model with zero inventory risks.",
              },
            ].map((card) => (
              <div
                key={card.title}
                className="group rounded-2xl bg-white border border-black/5 shadow-lg shadow-black/5 p-6 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-start gap-3">
                  <span className="text-2xl">{card.icon}</span>
                  <div>
                    <h4 className="text-lg font-semibold text-[var(--web-secondary-color)] group-hover:translate-x-0.5 transition">
                      {card.title}
                    </h4>
                    <p className="mt-2 text-[15px] leading-7 text-[var(--web-grey-color)]">
                      {card.body}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* ► Decorative 3 images were here previously: REMOVED as requested */}
        </div>
      </section>

      {/* Journey – convert to a single row of 3 compact cards with image on top & text below */}
      <section className="py-10 sm:py-14">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-[var(--web-secondary-color)]">
              Your Import Journey, Simplified
            </h3>
            <p className="mt-3 text-[15px] leading-7 text-[var(--web-grey-color)]">
              From product discovery to doorstep delivery — Importerr brings the 
             <strong> entire cross-border process into one platform</strong>,
              making global business accessible for all.
            </p>
          </div>

          {/* Three compact cards in one row on desktop, stack on small screens */}
          {/* <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-5">
           
            <div className="rounded-2xl border border-black/5 bg-white p-4 shadow-sm hover:shadow-md transition">
              <img
                src={StepOneImg}
                alt="AI Discovery"
                className="mx-auto h-24 w-auto object-contain"
              />
              <h4 className="mt-4 text-center font-semibold text-slate-900">
                AI Product Discovery
              </h4>
              <p className="mt-1 text-center text-sm text-slate-600">
                Recommendations + verified suppliers to start right.
              </p>
            </div>

            
            <div className="rounded-2xl border border-black/5 bg-white p-4 shadow-sm hover:shadow-md transition">
              <img
                src={StepTwoImg}
                alt="Transparent Ordering"
                className="mx-auto h-24 w-auto object-contain"
              />
              <h4 className="mt-4 text-center font-semibold text-slate-900">
                Transparent Ordering
              </h4>
              <p className="mt-1 text-center text-sm text-slate-600">
                Clear pricing with no middlemen or hidden costs.
              </p>
            </div>

            
            <div className="rounded-2xl border border-black/5 bg-white p-4 shadow-sm hover:shadow-md transition">
              <img
                src={StepThreeImg}
                alt="Logistics & Delivery"
                className="mx-auto h-24 w-auto object-contain"
              />
              <h4 className="mt-4 text-center font-semibold text-slate-900">
                Logistics & Delivery
              </h4>
              <p className="mt-1 text-center text-sm text-slate-600">
                Freight, customs, and doorstep delivery across India.
              </p>
            </div>
          </div> */}
        </div>
      </section>

      {/* Bottom spacing */}
      <div className="h-6" />
    </div>
  );
}
